import {isFeatureEnabled} from '@github-ui/feature-flags'

import {ContentfulLogoSuite} from '@github-ui/swp-core/components/contentful/ContentfulLogoSuite'
import {ContentfulPillars} from '@github-ui/swp-core/components/contentful/ContentfulPillars'
import type {PrimerComponentLogoSuite} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentLogoSuite'
import type {PrimerPillars} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerPillars'

import {Section} from '../../../../../brand/components/BrandPage'
import type {GenericSectionWithIds, GenericContent, GenericGroup} from '../../../../../brand/lib/types/contentful'

import {HeroContent} from './HeroContent'
import {HeroContent as HeroContentNext} from './HeroContentNext'
import {HeroTabs} from './HeroTabs'
import {HeroVideo} from './HeroVideo'

import styles from './HeroSection.module.css'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function HeroSection(props: Props) {
  const isUniverseEnabled = isFeatureEnabled('site_features_copilot_universe')
  const isVideoTabsEnabled = isFeatureEnabled('site_features_copilot_video_tabs_universe')
  const isPrimerBrandNextEnabled = isFeatureEnabled('primer_brand_next')

  const {contentfulContent} = props
  const {content} = contentfulContent.fields

  const {featuresCopilotHero, featuresCopilotHeroVideoTabs} = contentfulContent.ids as {
    featuresCopilotHero: GenericContent
    featuresCopilotHeroVideoTabs: GenericGroup
  }

  const {media} = featuresCopilotHero.fields

  const heroVideoLarge = media?.find(item => item.fields.id === 'heroVideoLarge')
  const heroVideoSmall = media?.find(item => item.fields.id === 'heroVideoSmall')
  const heroPosterLarge = media?.find(item => item.fields.id === 'heroPosterLarge')
  const heroPosterSmall = media?.find(item => item.fields.id === 'heroPosterSmall')

  const logosComponent = content?.find(item => item.sys.contentType.sys.id === 'primerComponentLogoSuite') as
    | PrimerComponentLogoSuite
    | undefined

  const pillarsComponent = content?.find(item => item.sys.contentType.sys.id === 'primerPillars') as
    | PrimerPillars
    | undefined

  return (
    <Section id="hero" className={styles.hero}>
      {isPrimerBrandNextEnabled ? (
        <HeroContentNext contentfulContent={featuresCopilotHero} />
      ) : (
        <HeroContent contentfulContent={featuresCopilotHero} />
      )}

      {!isVideoTabsEnabled && heroVideoLarge ? (
        <HeroVideo
          description={heroVideoLarge.fields.description}
          posterSrcLarge={heroPosterLarge?.fields.asset.fields.file.url}
          posterSrcSmall={heroPosterSmall?.fields.asset.fields.file.url}
          videoSrcLarge={heroVideoLarge.fields.asset.fields.file.url}
          videoSrcSmall={heroVideoSmall?.fields.asset.fields.file.url}
        />
      ) : null}

      {isVideoTabsEnabled && featuresCopilotHeroVideoTabs ? (
        <HeroTabs contentfulContent={featuresCopilotHeroVideoTabs} />
      ) : null}

      {logosComponent ? <ContentfulLogoSuite component={logosComponent} className={styles.logos} /> : null}

      {isUniverseEnabled && pillarsComponent ? (
        <ContentfulPillars component={pillarsComponent} className={styles.pillars} />
      ) : null}
    </Section>
  )
}
